import assetService from "../../../../services/assetService/assetService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_ASSETS } from "../../../../utils/constants";
import { DataSelectType } from "../../../../models/DataSelectType";
import { AssetInterface } from "../../../../models/AssetModel/Asset";

const useAssets = (
  page: number,
  pageSize: number,
  filters?: DataSelectType[]
) =>
  useQuery<AssetInterface[], Error>({
    queryKey: [
      CACHE_KEY_ASSETS,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => assetService.GetAll(page, pageSize, filters),
    initialData: [],
  });

export default useAssets;
